module.exports = __webpack_public_path__ + "static/img/B2Bbanner.0a23beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/B2Bbanner.png
// module id = J0EP
// module chunks = 1